module.exports = __webpack_public_path__ + "static/media/trash.310d0b56.svg";